import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  styled
} from '@mui/material';

interface TotalSummary {
  summary: string;
  gross: string;
  tare: string;
  net: string;
  netPge: string;
  numberOfItemsPge: string;
}

interface PostcardTotalSummaryTableProps {
  data: TotalSummary;
  direction: string;
}

// Styled components
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  borderRadius: '6px',
  border: '1px solid #E1E8ED',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
  overflow: 'auto',
  maxWidth: '600px',
}));

const StyledTable = styled(Table)({
  minWidth: 550,
});

const HeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#E7EFF5',
  color: '#063142',
  fontWeight: 600,
  fontSize: '12px',
  padding: '8px 12px',
  border: '1px solid #D0DCE7',
  textAlign: 'center',
}));

const DataCell = styled(TableCell)<{ direction?: string }>(({ theme, direction }) => ({
  fontSize: '12px',
  padding: '6px 12px',
  border: '1px solid #E1E8ED',
  textAlign: 'right',
  backgroundColor: direction === 'Inbound' ? 'rgb(230, 245, 230)' : 'rgb(255, 240, 240)',
  fontWeight: 700, // Total summary should be bold
}));

const SummaryLabelCell = styled(DataCell)({
  textAlign: 'left',
  fontWeight: 700,
});

function PostcardTotalSummaryTable({ data, direction }: PostcardTotalSummaryTableProps) {
  return (
    <StyledTableContainer>
      <StyledTable>
        <TableHead>
          <TableRow>
            <HeaderCell style={{ minWidth: '120px' }}>
              Summary
            </HeaderCell>
            <HeaderCell style={{ minWidth: '80px' }}>
              Gross
            </HeaderCell>
            <HeaderCell style={{ minWidth: '80px' }}>
              Tare
            </HeaderCell>
            <HeaderCell style={{ minWidth: '80px' }}>
              Net
            </HeaderCell>
            <HeaderCell style={{ minWidth: '80px' }}>
              Net P+G+E
            </HeaderCell>
            <HeaderCell style={{ minWidth: '100px' }}>
              Number of items (P+G+E)
            </HeaderCell>
          </TableRow>
        </TableHead>
        
        <TableBody>
          <TableRow>
            <SummaryLabelCell direction={direction}>
              {data.summary}
            </SummaryLabelCell>
            <DataCell direction={direction}>
              {data.gross}
            </DataCell>
            <DataCell direction={direction}>
              {data.tare}
            </DataCell>
            <DataCell direction={direction}>
              {data.net}
            </DataCell>
            <DataCell direction={direction}>
              {data.netPge}
            </DataCell>
            <DataCell direction={direction}>
              {data.numberOfItemsPge}
            </DataCell>
          </TableRow>
        </TableBody>
      </StyledTable>
    </StyledTableContainer>
  );
}

export default PostcardTotalSummaryTable;
